module.exports = __webpack_public_path__ + "img/sdk-writing.fff94cf7.png";